import { 
    useState, 
    useEffect, 
} from 'react';
import { 
    useTheme,
    useMediaQuery,
    Box, 
    Chip, 
    Tooltip,
    Link,
} from '@mui/material';
import { HelpRounded, OpenInNewRounded } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { withPather } from 'react-pather';
import { DataRow } from '../../../general';

const RedirectHistoryRow = ({ 
    pather, 
    redirect, 
    index, 
    isExpanded, 
    hoveredIndex, 
    setHoveredIndex
}) => {

    const navigate = useNavigate();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));
    const matchesDownSm = useMediaQuery(theme.breakpoints.down('sm'));
    const [currentIsExpanded, setCurrentExpansion] = useState(false);
    const [isCurrentHovered, setIsCurrentHovered] = useState(false);

    useEffect(() => {
        setCurrentExpansion(false);
    }, [isExpanded]);

    const toggleCurrentExpansion = () => {
        if (!isExpanded) setCurrentExpansion(!currentIsExpanded);
    }

    const redirectData = (
        <Box sx={{marginLeft: !matches && 'auto', cursor: 'pointer', alignSelf: !matches && 'center'}}>
            <Tooltip title='Redirect date' placement={isExpanded ? (matches ? 'right' : 'bottom') : 'left'}>
                { redirect.date }
            </Tooltip>
        </Box>
    );

    let linkComp = null;
    if (redirect?.conversion_code) {

        const composedUrl = `${window.location.origin}${pather.reverse(pather.front.main, { code: redirect.conversion_code })}`;
        
        linkComp = (
            <Box sx={{display: 'flex', flexDirection: matches ? 'column' : 'row', gap: 1.5}}>

                <Box sx={{display: 'flex', gap: 1, width: {xs: '100%', md: '70%'}}}>
                    <Box sx={{
                        fontSize: '26px',
                        overflowX: 'auto', 
                        colorScheme: theme.palette.mode === 'dark' ? 'dark' : 'light', 
                        whiteSpace: 'nowrap',
                        "&::-webkit-scrollbar": {
                            height: "8px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: theme.palette.mode === "light" ? "#c1c1c1" : "#6b6b6b",
                            borderRadius: "4px",
                            cursor: 'grab',
                        },
                        "&::-webkit-scrollbar-track": {
                            backgroundColor: theme.palette.mode === "light" ? (isCurrentHovered ? "#E6E6E6" : "#F0F0F0") : theme.palette.background.paper,
                            borderRadius: "4px",
                        },
                        '&::-webkit-scrollbar-thumb:active': {
                            cursor: 'grabbing',
                        },
                    }}>
                        <Link 
                            href={composedUrl}
                            target="_blank" rel="noreferrer" 
                            sx={{
                                ...theme.link, 
                                cursor: 'pointer',
                            }}
                            onClick={e => e.stopPropagation()}
                        >
                            {
                                matchesDownSm ? 
                                redirect.conversion_code : 
                                composedUrl
                            } 
                        </Link>
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <Tooltip title="Open">
                            <OpenInNewRounded 
                                fontSize='small' 
                                onClick={() => navigate(pather.reverse(pather.front.view, { code: redirect.conversion_code }))}
                            />
                        </Tooltip>
                    </Box>
                </Box>

                {redirectData}

            </Box>
        )
    }

    return (
        <DataRow
            index={index}
            hoveredIndex={hoveredIndex} 
            setHoveredIndex={setHoveredIndex} 
            onMouseEnter={() => {
                setIsCurrentHovered(true);
            }}
            onMouseLeave={() => {
                setIsCurrentHovered(false);
            }}
            onClick={toggleCurrentExpansion}
        >
            {linkComp}
            <Box sx={{display: 'flex', flexDirection: matches ? 'column' : 'row', gap: matches && 1}}>
                <Box sx={{display: 'flex', gap: 2, alignItems: 'center'}}>
                    <Box sx={{fontSize: '1.7rem'}}>
                        {
                            redirect.ip_addr ? 
                            redirect.ip_addr : 
                            'ANONIM'
                        }
                    </Box>
                    <Box>
                        {   
                            redirect?.is_successful ?
                            <Chip color="success" size='small' label="Successful" sx={{color: 'white'}} /> :
                            <Chip color="error" size='small' label="Failed" />
                        }
                    </Box>
                </Box>
                { !linkComp && redirectData }
            </Box>
            {
                (isExpanded || currentIsExpanded) &&
                <>
                    {
                        redirect?.status_message &&
                        <Box sx={{display: 'flex', gap: .5, alignItems: 'flex-end'}}>
                            <Box sx={{fontWeight: 'bold'}}>
                                {redirect.status_message}
                            </Box>
                            {
                                redirect?.status_explanation &&
                                <Tooltip 
                                    title={redirect.status_explanation} 
                                    placement="right" 
                                    sx={{cursor: 'pointer'}} 
                                    arrow
                                >
                                    <HelpRounded fontSize='small'/>
                                </Tooltip>
                            }
                        </Box>
                    }
                    {   
                        redirect?.user_agent &&
                        <Box>
                            {redirect.user_agent}
                        </Box>
                    }
                </>
            }
        </DataRow>
    );
}

export default withPather()(RedirectHistoryRow);